<template>
  <v-content>
    <v-dialog
      v-model="dialog.isShow"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{dialog.title}}
        </v-card-title>

        <v-card-text>
          {{dialog.content}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog.isShow = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar class="bg-color" dark extended flat>
      <v-btn dark icon href="http://presentria.ca/">
        <v-icon>home</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout wrap column pb-2 justify-center>
      <v-flex xs12 sm10 md8>
        <v-flex xs12 d-flex justify-center>
          <v-card class="card--flex-toolbar" style="max-width:750px">
            <v-toolbar card prominent>
              <v-toolbar-title class="body-2 grey--text">Account Registration</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 sm7>
                  <v-card-title class="pb-0">
                    <div>
                      <h3 class="headline mb-0">Create your Presentria Account</h3>
                      <span class="grey--text">to enjoy the application!</span>
                    </div>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                    <v-container fluid grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.firstName" :rules="[formRules.required]" label="First name" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.lastName" :rules="[formRules.required]" label="Last name" required></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="registration.email" :rules="[formRules.requiredEmail, formRules.formatEmail]" label="E-mail" required></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="registration.username" :rules="[formRules.formatLoginName]" label="Username" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.password" :rules="[formRules.required, formRules.lengthPassword]" type="password" label="Password" required></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="registration.confirmPassword" :rules="[formRules.valuePassword]" type="password" label="Confirm" required></v-text-field>
                        </v-flex>
                        <v-flex v-if="!hideReferenceField" xs12>
                          <v-text-field v-model="registration.reference" label="Reference Code (Optional)"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout>
                            <v-checkbox
                              v-model="isConfirmed"
                              :rules="[formRules.required]"
                              hide-details
                            ></v-checkbox>
                            <span>
                              I have read and agree with the Presentria
                              <a href="http://presentria.ca/terms-and-conditions/"
                              >Terms and Conditions</a>,
                            <a href="http://presentria.ca/acceptable-use-policy/"
                              >Acceptable Use Policy</a>, and
                              <a href="http://presentria.ca/privacy-policy/"
                              >Privacy Policy</a> . (required)
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-layout xs12 justify-space-between class="mt-3">
                          <v-btn flat color="teal" @click="goHome()">Sign in instead</v-btn>
                          <v-btn color="teal" class="white--text" :disabled="!valid" @click="submit()">Register</v-btn>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-flex>
                <v-flex xs12 sm5 class="hidden-xs-only pt-5">
                  <v-img contain class="ma-3" src="/assets/key.png"></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 d-flex justify-center>
          <v-layout class="my-2" style="max-width:750px">
            <v-btn flat small color="grey" @click="goForgetPassword">Forgot Password?</v-btn>
            <v-btn flat small color="grey" @click="goResendVerification">No verification email?</v-btn>
            <v-btn flat small color="grey" href="http://presentria.ca/privacy-policy/">Privacy Policy</v-btn>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
  import validator from 'validator';
  export default {
    props: {
      navigateTo: Function
    },
    data() {
      return {
        dialog: {
          isShow: false,
          title: '',
          content: '',
        },
        isConfirmed: false,
        formRules: {
          required: v => !!v || 'This field is required',
          requiredEmail: v => !!v || 'A valid email address is required',
          formatEmail: v => validator.isEmail(v) || 'Invalid email address',
          formatLoginName: (v) => {
            const allowedCharacters = new RegExp('^([a-zA-Z0-9-_.@]+)$');
            const atLeastOneAlphanumeric = new RegExp('^.*[a-zA-Z0-9]+.*$');
            // automatically accept any valid email address
            if (validator.isEmail(v)) {
              return true;
            }
            if (v.length < 3) {
              return 'Your username should be at least 3 characters long';
            }
            if (!allowedCharacters.test(v)) {
              return 'Your username should be composed of alphabets, numbers or the symbols - _ . @';
            }
            if (!atLeastOneAlphanumeric.test(v)) {
              return 'Your username should have at least one alphabet or number';
            }
            return true;
          },
          lengthPassword: v => v.length >= 8  || 'Your password should be at least 8 characters long',
          valuePassword: v => v === this.registration.password || 'Your passwords do not match',
        },
        valid: false,
        registration: {
          username: '',
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          confirmPassword: '',
          reference: this.$route.query.ref || '',
        },
        hideReferenceField: !!(this.$route.query.ref),
      };
    },
    methods: {
      submit() {
        let self = this;
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          this.axios.post('public/register', {
            username: this.registration.username,
            firstName: this.registration.firstName,
            lastName: this.registration.lastName,
            email: this.registration.email,
            password: this.registration.password,
            reference: this.registration.reference,
          }).then(() => {
            self.dialog.title = 'Registration successful';
            self.dialog.content = 'Registration successful. Please check your email inbox to activate your account.';
            self.dialog.isShow = true;
          }).catch((err) => {
            if (err.response.status === 409) {
              self.dialog.title = 'Invalid username or Email';
              self.dialog.content = 'Your username or email address already exists. Please enter another one.';
              self.dialog.isShow = true;
            } else if (err.response.status === 400) {
              self.dialog.title = 'Registration failed';
              self.dialog.content = err.response.data;
              self.dialog.isShow = true;
            } else {
              self.dialog.title = 'Registration failed';
              self.dialog.content = 'Registration failed. Please contact us at enquiry@presentria.com';
              self.dialog.isShow = true;
            }
          });
        }
      },

      goHome() {
        window.location.href = '/instructor';
      },
      goForgetPassword() {
        this.$router.push({name: 'ForgetPassword'});
      },
      goResendVerification() {
        this.$router.push({name: 'ResendVerify'});
      },
    }
  };
</script>

